import React, { Component } from 'react'
import { Link } from 'react-scroll'
import update from 'react-addons-update'
import { logo } from '../../assets/imgs'
import { scrollToTop } from '../../services'
import ExpandedMenu from './expanded-menu'
import './index.css'

let scrollTicking = false

const navLinks = [{
  to: 'press',
  text: 'In the Media'
}, {
  to: 'areas',
  text: 'Areas of Practice & Testimonials'
}, {
  to: 'about',
  text: 'About'
}, {
  to: 'contact',
  text: 'Contact'
}]

class Header extends Component {
  constructor () {
    super()
    this.state = { menuShown: false, isSticky: null, offsetHeight: null }
    this.header = null
    this.toggleMenu = this.toggleMenu.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.updateStickyHeader = this.updateStickyHeader.bind(this)
  }

  componentDidMount () {
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', e => { this.updateStickyHeader(window.scrollY) })
    this.updateStickyHeader(window.scrollY)
  }

  toggleMenu () {
    this.setState(update(this.state, {
      menuShown: { $apply: b => !b }
    }))
  }

  onScroll () {
    let lastKnownScrollPos = window.scrollY
    if (!scrollTicking) {
      window.requestAnimationFrame(() => {
        this.updateStickyHeader(lastKnownScrollPos)
        scrollTicking = false
      })
    }
    scrollTicking = true
  }

  updateStickyHeader (scrollPos) {
    const desktopHeaderStyle = window.getComputedStyle(this.desktopHeader)
    const isMobile = desktopHeaderStyle.display === 'none'

    if (isMobile) {
      this.props.setContentPadding(this.mobileHeader.offsetHeight)
      this.setState({ isSticky: true, offsetHeight: 0 })
    } else {
      const img = this.desktopHeader.querySelector('img')
      const imgStyle = window.getComputedStyle(img)

      const padding = parseInt(desktopHeaderStyle.paddingTop, 10)
      const imgHeight = parseInt(imgStyle.height, 10)

      const offsetHeight = padding + imgHeight
      const contentPadding = this.desktopHeader.offsetHeight
      const isSticky = scrollPos > offsetHeight

      this.props.setContentPadding(isSticky ? contentPadding : 0)
      this.setState({ isSticky, offsetHeight })
    }
  }

  render () {
    const { menuShown, isSticky, offsetHeight } = this.state

    const headerStyle = isSticky ? {
      position: 'fixed',
      top: -offsetHeight,
      right: 0,
      left: 0,
      zIndex: 1
    } : {}

    return (
      <header className="header" style={headerStyle}>
        <header className="pa2 bg-white flex flex-row justify-between items-center dn-ns pa3-m" ref={el => { this.mobileHeader = el }}>
          <span className="f6 fw3 f5-m pointer" onClick={this.toggleMenu}>Menu</span>
          <img src={logo} className="header__logo" alt="logo" onClick={scrollToTop} />
          <a className="f6 fw3 f5-m pointer" href="https://medium.com/@philliphamilton">Blog</a>
          {menuShown && <ExpandedMenu onClose={this.toggleMenu} offset={this.mobileHeader.offsetHeight} />}
        </header>

        <div className="pa2 dn flex-ns bg-white flex-column items-center" ref={el => { this.desktopHeader = el }}>
          <img src={logo} className="header__logo mb4" alt="logo" />
          <nav className="flex flex-row justify-center fw3">
            {navLinks.map(({ to, text }) => (
              <Link className="mh3 trans-quick f7-m f5-l header__link" to={to} activeClass="red" spy key={to} smooth isDynamic>{text}</Link>
            ))}
            <a className="mh3 f7-m f5-l header__link" href="https://medium.com/@philliphamilton">Blog</a>
          </nav>
        </div>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js